import _ from 'lodash'
import { useSubscribers } from '../../../../../store/subscription/useSubscribers'
import { ChangePlanActions } from './ChangePlanActions'
import moment from "moment";

import { Container, Actions, Confirmation } from './styles'

export function SubscriptionDetailsPlans() {
  const availablePlans = useSubscribers(st => st.data.availablePlans)
  const queueJobs = useSubscribers(st => st.data.details.queueJobs || [])

  const lastJob = _.findLast(queueJobs, (job) => job.jobName === "Alterar Plano Assinatura")
  if (!availablePlans) return null

  const createdAt = moment(new Date(lastJob?.raw.createdAt))
  const confirmationAt = moment(new Date(lastJob?.raw.data?.confirmationDate))
  const diff = moment().diff(createdAt, 'hours')

  const isPending = lastJob?.jobStatus === "Pendente"
  const isScheduled = lastJob?.jobStatus === "Programado"
  const newPlanName = lastJob?.raw.data?.newPlan?.description || '-'

  // const show = isScheduled || (isPending && diff <= 24 * 10)

  return (
    <Container>
      {isPending && (
        <Confirmation className='px-2 mb-4 text-yellow-800 bg-yellow-50 border border-yellow-400/50 flex-1 mx-2'>
          <p className='font-semibold text-lg'>Confimação pentente</p>
          <div className='px-2'>
            <p><strong>Link foi enviado dia {createdAt.format('DD/MM/YYYY')}</strong></p>
            <p>‼️O cliente ainda não confirmou a troca para o plano <strong>{newPlanName}</strong>.</p>
            <p>⚠️ Oriente o cliente <strong>confirmar pelo e-mail</strong> ou <strong>finalizar no app</strong>. Se preferir, você também pode <strong>reenviar o link</strong>.</p>
          </div>
        </Confirmation>
      )}
      {isScheduled && (
        <Confirmation className='px-2 mb-4 text-emerald-800 bg-emerald-50 border border-emerald-400/50 flex-1 mx-2'>
          <p className='font-semibold text-lg'>Troca programada</p>
          <div className='px-2'>
            <p><strong>Link enviado em:</strong> {createdAt.format('DD/MM/YYYY')}</p>
            <p><strong>✅ Cliete confirmou dia:</strong> {confirmationAt.format('DD/MM/YYYY')}</p>
            <p>Plano novo:<strong>{newPlanName}</strong>.</p>
            <p>🗓️ A mudança será aplicada em <strong>{moment(lastJob?.raw.data.nextBillingAt).format('DD/MM/YYYY')}</strong>.</p>
          </div>
        </Confirmation>
      )}

      <Actions>
        {availablePlans.map((availablePlan) => (
          <ChangePlanActions plan={availablePlan} />
        ))}
      </Actions>
    </Container>
  )
}
